<template>
  <div class="border border-gray-500 rounded-lg pt-4 pb-2 px-3 flex flex-col justify-around"
    :class="{ '!bg-blue-background !border-blue': mode == 'secondary' }">
    <div class="flex flex-wrap items-center gap-x-1 gap-y-1" :class="{ '!gap-x-3': large }">
      <img :src="item.icon" :height="large ? '40' : '30'" :width="large ? '40' : '30'" :alt="item.title">
      <div class="">
        <h3 class="text-sm text-gray-dark font-medium" :class="[{ '!text-base': large }, {'pr-[37px]': item.title == $t('contestants')}]">{{ item.title }}</h3>
        <p v-if="item.statisticTime && item.statisticTime.length > 0" class="text-xs text-gray-900">
          {{ item.statisticTime }} ({{$t('GMT')}})</p>
      </div>
    </div>
    <div class="rounded-lg bg-blue-background mt-2"
      :class="[{ '!mt-4': large }, { '!bg-white border border-blue': mode == 'secondary' }, {'!bg-[#2d394b26]': type === 'finished' || type === 'upcoming'}]">
      <div v-if="item.remainingTime && item.remainingTime.length > 0">
        <RemainingTime :targetDate="item.remainingTime" :showTitle="false" size="small" />
      </div>
      <p v-else-if="item.statisticValueDate && item.statisticValueDate.length > 0"
        class="px-3 py-2 text-xs text-blue font-medium" :class="[{ '!text-base text-center': large }, {'!py-3.5': mode == 'secondary'}, {'!text-gray-900': type === 'upcoming'}]">
        {{ item.statisticValueDate }}</p>
      <p v-else-if="Number.isInteger(item.statisticValueNumber) && item.statisticValueNumber >= 0"
        class="px-4 py-2 text-xs text-blue font-medium" :class="[{ '!text-base text-center': large }, {'!py-3.5': mode == 'secondary'}, {'!text-gray-900': type === 'upcoming'}]">
        {{ item.statisticValueNumber }}</p>
        <p v-else class="px-4 py-2 text-xs text-blue font-medium" :class="[{ '!text-base text-center': large }, {'!py-3.5': mode == 'secondary'}]"> <span class="opacity-0">1</span> </p>
    </div>
  </div>
</template>

<script>
import RemainingTime from './RemainingTime.vue';
export default {
  name: 'statistics-card',
  components: { RemainingTime },
  data() {
    return {}
  },
  props: {
    item: Object,
    large: Boolean,
    mode: {
      type: String,
      default: "primary" // or secondary for the leaderboard
    },
    type: {
      type: String,
      default: 'inprogress'
    }
  },
  watch: {},
  computed: {},
  methods: {}
}
</script>
